import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { resolveLandingMedia } from "../../utils/landingMedia";

function usableName(value) {
  const name = String(value || "").trim();
  if (!name || name.toLowerCase() === "mi negocio") return "";
  return name;
}

export default function StorefrontLoadingScreen({ businessName = "", logoUrl = "", compact = false }) {
  const name = usableName(businessName);
  const logo = resolveLandingMedia(logoUrl);
  const hasBrand = Boolean(name || logo);

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        minHeight: compact ? 300 : "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        px: 3,
        bgcolor: "background.default",
      }}
    >
      <Box sx={{ width: "min(360px, 86vw)", textAlign: "center" }}>
        {logo ? (
          <Box
            component="img"
            src={logo}
            alt=""
            aria-hidden="true"
            sx={{
              width: compact ? 58 : 72,
              height: compact ? 58 : 72,
              objectFit: "contain",
              borderRadius: 2,
              animation: "storefrontLoaderPulse 1.5s ease-in-out infinite",
              "@keyframes storefrontLoaderPulse": {
                "0%, 100%": { transform: "scale(.94)", opacity: 0.72 },
                "50%": { transform: "scale(1)", opacity: 1 },
              },
            }}
          />
        ) : null}
        {name ? (
          <Typography sx={{ mt: logo ? 1.6 : 0, fontWeight: 900, color: "text.primary", fontSize: compact ? 17 : 19 }}>
            {name}
          </Typography>
        ) : null}
        <LinearProgress
          aria-label={hasBrand ? `Cargando ${name || "sitio"}` : "Cargando sitio"}
          sx={{
            mt: hasBrand ? 2.2 : 0,
            height: 5,
            borderRadius: 999,
            bgcolor: "action.hover",
            "& .MuiLinearProgress-bar": { borderRadius: 999 },
          }}
        />
      </Box>
    </Box>
  );
}
